import { format, isToday, isTomorrow, startOfDay } from 'date-fns';
import { assertUnreachable } from 'utils';
import { getOrdinal } from 'utils/formatting';
export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const getAutoInvestDisplayStatus = (planStatus, mandateActive, connectedAccountDoesntMatch) => {
    if ((planStatus === 'active' || planStatus === 'paused') && mandateActive === false) {
        if (connectedAccountDoesntMatch) {
            return 'DIRECT_DEBIT_ACCOUNT_CHANGED';
        }
        return 'DIRECT_DEBIT_CANCELLED';
    }
    if (planStatus === 'pausing' || planStatus === 'paused')
        return 'Paused';
    if (planStatus === 'active' && mandateActive)
        return 'Working';
    return 'Pending';
};
export const getNextCollectionDate = (dayOfMonth) => {
    const today = startOfDay(new Date());
    const thisMonth = new Date(today.getFullYear(), today.getMonth(), dayOfMonth);
    if (thisMonth >= today)
        return thisMonth;
    return new Date(today.getFullYear(), today.getMonth() + 1, dayOfMonth);
};
export const getNextCollectionLabel = (dayOfMonth) => {
    const date = getNextCollectionDate(dayOfMonth);
    if (isToday(date))
        return 'Next invest today';
    if (isTomorrow(date))
        return 'Next invest tomorrow';
    return `Next invest on ${format(date, 'd MMM')}`;
};
export const formatUpcomingDate = (timestamp) => {
    const date = new Date(timestamp);
    if (isToday(date))
        return 'today';
    if (isTomorrow(date))
        return 'tomorrow';
    return `the ${getOrdinal(date.getDate())} of ${MONTHS[date.getMonth()]}`;
};
export const formatPausedUntil = (pausedUntil) => {
    const date = new Date(pausedUntil);
    const day = DAYS_OF_WEEK[date.getDay()];
    const ordinal = getOrdinal(date.getDate());
    const month = MONTHS[date.getMonth()];
    return `Your Autoinvest is on hold until ${day}, the ${ordinal} of ${month}. Tap resume to start again.`;
};
export const getPausedUntilLabel = (pausedUntil) => {
    const date = new Date(pausedUntil);
    return `Paused until ${getOrdinal(date.getDate())} ${MONTHS[date.getMonth()]}`;
};
export const getAutoInvestActionRequiredLabel = (actionRequired, bankName, investAccountName) => {
    const suffix = investAccountName ? ` for your ${investAccountName}` : '';
    switch (actionRequired) {
        case 'DIRECT_DEBIT_CANCELLED':
            if (bankName) {
                return `Your Direct Debit has been cancelled by ${bankName}. Please set it up again to continue autoinvesting${suffix}`;
            }
            return `Direct debit has been cancelled by your bank. Fix the connection to continue autoinvesting${suffix}`;
        case 'DIRECT_DEBIT_ACCOUNT_CHANGED':
            return `Your funding account has changed. Please set up a new Direct Debit to continue autoinvesting${suffix}`;
        default:
            assertUnreachable(actionRequired);
            return `Direct debit has been cancelled by your bank. Fix the connection to continue autoinvesting${suffix}`;
    }
};
